import React from 'react'

const CardExpert = ({data, short, bookmark, embed}) => {
  const {
    image,
    organization,
    title,
  } = data

  return (
    <div
      className="bg-white rounded p-4 lg:p-8 h-full text-center"
      style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'}}
    >
      <div
        className="bg-no-repeat bg-cover bg-center mb-3 lg:mb-5 rounded rounded-full p-2 mx-auto"
        style={{backgroundImage: `url('${image}')`, width: '120px', height: '120px'}}
      >
      </div>
      <h3 className="lg:text-lg font-bold lg:mb-2 font-primary">{title}</h3>
      <p className="text-gray-500 text-sm mb-2">{organization}</p>
    </div>
  )
}

export { CardExpert }